
import { Placement } from '@post-office/placements-frontend/jira-nin-meatball-menu-button';
export default Placement;
